import { render, staticRenderFns } from "./FormaPago.vue?vue&type=template&id=03bcfdc6&"
import script from "./FormaPago.vue?vue&type=script&lang=js&"
export * from "./FormaPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports